import { useEffect, useState } from 'react';

interface Particle {
  id: number;
  x: number;
  y: number;
  size: number;
  duration: number;
  delay: number;
}

const ParticleBackground = () => {
  const [particles, setParticles] = useState<Particle[]>([]);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Use requestIdleCallback for truly non-critical work (with fallback)
    const scheduleParticles = () => {
      const newParticles: Particle[] = [];
      const particleCount = 15; // Further reduced for better performance

      for (let i = 0; i < particleCount; i++) {
        newParticles.push({
          id: i,
          x: Math.random() * 100,
          y: Math.random() * 100,
          size: Math.random() * 3 + 2,
          duration: Math.random() * 25 + 20,
          delay: Math.random() * 3,
        });
      }

      setParticles(newParticles);
      setIsReady(true);
    };

    // Defer particles until after LCP and browser is idle
    const timeoutId = setTimeout(() => {
      if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(scheduleParticles, { timeout: 3000 });
      } else {
        scheduleParticles();
      }
    }, 2000); // Increased delay to 2s for better LCP

    return () => clearTimeout(timeoutId);
  }, []);

  if (!isReady) {
    return <div className="absolute inset-0 overflow-hidden pointer-events-none" />;
  }

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none will-change-auto">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="absolute rounded-full bg-primary/15 animate-float-particle"
          style={{
            left: `${particle.x}%`,
            top: `${particle.y}%`,
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            animationDuration: `${particle.duration}s`,
            animationDelay: `${particle.delay}s`,
            willChange: 'transform',
          }}
        />
      ))}
    </div>
  );
};

export default ParticleBackground;
